import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class FeedbackDeliveryUnread extends PrimitiveValueObject<boolean> {
  static create(value: boolean): FeedbackDeliveryUnread {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new FeedbackDeliveryUnread(value);
  }
}
